import { get } from 'lodash'

import { Container, Item, getTranslatedString } from '@skinsoft/types'
import { itemSelectors } from '.'

export const futureLocation = (container: Container, locale: string) =>
    getTranslatedString(
        get(container, 'locationItemSchema.futureLocation.futureLocation.path'),
        locale,
    )

export const location = (container: Container, locale: string) => {
    const path = get(container, 'locationItemSchema.realTimeLocation.realTimeLocation.path', undefined)
    // @ts-ignore
    if(path && path.translatedString) {
        return getTranslatedString(path, locale)
    }

    return get(container, 'locationItemSchema.realTimeLocation.realTimeLocation')
}

export const typeOfContent = (container: Container) => get(container, 'containerItemDataSchema.typeOfContent')

export const itemType = (container: Container) => get(container, 'descriptionItemSchema.itemType')

/**
 * Items fields
 */
export const inventoryNumber = (container: Container) => {
    // @ts-ignore (ts-ignore could be retired when typing of interfaces Item and Container is finished)
    // A container is an item
    return itemSelectors.inventoryNumber(container as Item)
}
